import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { faqs } from "@/mocks/chiGuaData";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <SectionHeading
              index="04"
              en="Gua FAQ"
              title="吃瓜前，先弄清规矩"
              desc="围观也要有边界。把最常见的疑问放在这里，让你吃瓜不踩坑、不传谣。"
            />
            <div className="mt-6 flex items-start gap-3 rounded-xl border border-accent-200 bg-accent-100/60 p-4 text-sm leading-relaxed text-accent-900">
              <i className="ri-emotion-laugh-line mt-0.5 text-lg" />
              <p>
                一句话原则：<strong>只看公开可查证的物料，不针对私生活做主观猜测。</strong>
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="space-y-3">
              {faqs.map((f, i) => {
                const isOpen = openIdx === i;
                return (
                  <div
                    key={f.q}
                    className={`overflow-hidden rounded-xl border transition-colors ${
                      isOpen
                        ? "border-primary-300 bg-primary-50/60"
                        : "border-background-200/70 bg-background-100/60 hover:border-primary-200"
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpenIdx(isOpen ? -1 : i)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <h3 className="text-sm font-semibold leading-snug text-foreground-900 md:text-base">
                        <span className="mr-2 text-primary-500">Q{i + 1}.</span>
                        {f.q}
                      </h3>
                      <span
                        className={`flex h-7 w-7 flex-none items-center justify-center rounded-full transition-all ${
                          isOpen ? "rotate-45 bg-primary-500 text-background-50" : "bg-background-50 text-foreground-600"
                        }`}
                      >
                        <i className="ri-add-line" />
                      </span>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5">
                        <p className="border-l-2 border-primary-200 pl-4 text-sm leading-relaxed text-foreground-700">
                          {f.a}
                        </p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}